import React from "react";
import { formatDate, formatDateTime } from "../../i18n/dateLocale";
import { useTranslation } from "react-i18next";

const IvtsStocksTable = (props) => {
  const { t } = useTranslation();
  return (
    <div className="table-wrapper px-3 pt-3">
      <div className="d-flex justify-content-between pb-1 align-items-end">
        <div className="table-type">{t("admin.ivtsStocks.stockTransactions")}</div>
      </div>
      <div className="table-wrapper-scroll-y table-scrollbar">
        <div className="table-own table-responsive">
          <table className="table table-striped table-hover table-admin">
            <thead className="table-head">
              <tr>
                <th>{t("common.id")}</th>
                <th>{t("admin.ivtsStocks.stockEdited")}</th>
                <th>{t("common.date")}</th>
                <th>{t("common.time")}</th>
                <th>{t("common.notes")}</th>
                <th>{t("admin.ivtsStocks.users")}</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {props?.dataList &&
                props?.dataList.map((item, index) => (
                  <tr key={index}>
                    <td>{index+1}</td>
                    <td>{item?.stockQuantity || t("common.na")}</td>
                    <td>
                     {item?.timestamp?formatDate(new Date(item?.timestamp)):t("common.na")}
                    </td>
                    <td>
                    {item?.timestamp?formatDate(new Date(item?.timestamp), "p"):t("common.na")}

                    </td>
                    <td>{item?.notes || t("common.na")}</td>
                    <td>{item?.adminUser?.email || t("common.na")}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default IvtsStocksTable;
